import React from 'react'
import * as Popover from '@radix-ui/react-popover'

import './styles.css'

export default function PopOver({
    trigger,
    sideOffset = 0,
    side = 'left',
    align = 'top',
    alignOffset = 0,
    padding = true,
    avoidCollisions = true,
    defaultOpen = undefined,
    children,
    close,
    forceAnchor = false,
    open = undefined,
    hideArrow = false,
    style = {},
    asChild = false,
    onOpenChange = () => {},
    onFocusOutside = () => {},
    onOpenAutoFocus = () => {},
    onCloseAutoFocus = () => {},
    onInteractOutside = () => {},
    ...rest
}) {
    return (
        <Popover.Root defaultOpen={defaultOpen} open={open} onOpenChange={onOpenChange}>
            {!forceAnchor && asChild && <Popover.Trigger asChild>{trigger}</Popover.Trigger>}
            {!forceAnchor && !asChild && <Popover.Trigger style={style}>{trigger}</Popover.Trigger>}
            {forceAnchor && <Popover.Anchor asChild={true}></Popover.Anchor>}
            <Popover.Portal>
                <Popover.Content
                    className='PopoverContent'
                    style={{ padding: padding ? undefined : 0 }}
                    sideOffset={sideOffset}
                    side={side}
                    align={align}
                    alignOffset={alignOffset}
                    avoidCollisions={avoidCollisions}
                    onOpenAutoFocus={onOpenAutoFocus}
                    onInteractOutside={onInteractOutside}
                    onFocusOutside={onFocusOutside}
                    onCloseAutoFocus={onCloseAutoFocus}
                >
                    {children}

                    {!!close && (
                        <Popover.Close className='PopoverClose' aria-label='Close'>
                            {close}
                        </Popover.Close>
                    )}
                    {!!hideArrow && <Popover.Arrow className='PopoverArrow' />}
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    )
}
